/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './BlankTemplate.style';

import MainSwitch from 'src/shared/app/base/component/switch/MainSwitch';

const useStyles = createUseStyles(styles);

const BlankTemplate = (): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <div className={classes.root}>
      <MainSwitch layoutClass={classes.main} />
    </div>
  );
};

export default compose(React.memo)(BlankTemplate);
